
export default {
    competencia: {},
    competencias: []
}